export default {
  oauth2: {
    clientId: '36103006767-uon93aatpv94gqev945eudhmfsfoh7e4.apps.googleusercontent.com'
  }
};
